import React from "react";
import {Input, InputNumber, Select, Tooltip} from "antd";
import {DeleteOutlined, InfoCircleOutlined} from "@ant-design/icons";
import {daysList2} from "constants/constants";
import config from "_core/config";
import {
    CustomTimeItem,
    CustomTimeItemBody,
    CustomTimeItemActions,
    RemoveButton,
    CompactFormItem,
    CompactLabel
} from "../PoolPaymentContractForm.styles";

const KDV_RATE = config.KDV;

// KDV tooltip içeriği oluşturma fonksiyonu
const getKdvTooltipContent = (amount, isClientAmount) => {
    if (!amount || amount === "" || parseFloat(amount) === 0) return null;

    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount)) return <></>;

    // Müşteri ücreti KDV hariç, Kurye ücreti KDV dahil
    let includeVAT, excludeVAT;
    if (isClientAmount) {
        // Müşteri: girilen değer KDV hariç
        excludeVAT = numericAmount;
        includeVAT = numericAmount * (1 + KDV_RATE);
    } else {
        // Kurye: girilen değer KDV dahil
        includeVAT = numericAmount;
        excludeVAT = numericAmount / (1 + KDV_RATE);
    }

    return (
        <div style={{fontSize: 12}}>
            <div>KDV Dahil: {includeVAT.toFixed(2)} ₺</div>
            <div>KDV Hariç: {excludeVAT.toFixed(2)} ₺</div>
            <div style={{marginTop: 4, color: "#faad14"}}>KDV: %{(KDV_RATE * 100).toFixed(0)}</div>
        </div>
    );
};

export const PoolCustomTimeFeeItem = ({
    feeItem,
    feeType,
    index,
    disabled,
    onRemove,
    onChange,
    userIsCustomer
}) => {
    const handleFieldChange = (field, value) => {
        onChange(index, field, value);
    };

    const handleOptionsChange = (field, value) => {
        onChange(index, `options.${field}`, value);
    };

    const getSelectedDays = () => {
        const days = feeItem.options?.days || {};
        return Object.keys(days)
            .filter(key => days[key] === true || days[key] === "true")
            .map(key => {
                const day = daysList2.find(d => d.value.toString() === key);
                return day?.name || "";
            })
            .filter(Boolean);
    };

    const selectedDaysText = getSelectedDays().join(", ") || "Gün seçilmedi";

    return (
        <CustomTimeItem>
            <CustomTimeItemBody>
                <CompactFormItem>
                    <CompactLabel>
                        {userIsCustomer ? "Ücret:" : "Müşteri Ücreti:"}{" "}
                        {feeItem.clientAmount ? (
                            getKdvTooltipContent(feeItem.clientAmount, true) && (
                                <Tooltip title={getKdvTooltipContent(feeItem.clientAmount, true)}>
                                    <InfoCircleOutlined style={{color: "#1890ff"}} />
                                </Tooltip>
                            )
                        ) : (
                            <InfoCircleOutlined />
                        )}
                    </CompactLabel>
                    <InputNumber
                        className="payment-contract-form-input"
                        type="number"
                        size="small"
                        value={feeItem.clientAmount}
                        onChange={e => handleFieldChange("clientAmount", Math.abs(e))}
                        disabled={disabled}
                        min={0}
                        style={{width: 90}}
                    />
                </CompactFormItem>

                {!userIsCustomer && (
                    <CompactFormItem>
                        <CompactLabel>
                            Kurye Ücreti:{" "}
                            {feeItem.courierAmount ? (
                                getKdvTooltipContent(feeItem.courierAmount, false) && (
                                    <Tooltip
                                        title={getKdvTooltipContent(feeItem.courierAmount, false)}
                                    >
                                        <InfoCircleOutlined style={{color: "#1890ff"}} />
                                    </Tooltip>
                                )
                            ) : (
                                <InfoCircleOutlined />
                            )}
                        </CompactLabel>
                        <InputNumber
                            className="payment-contract-form-input"
                            type="number"
                            size="small"
                            value={feeItem.courierAmount}
                            onChange={e => handleFieldChange("courierAmount", Math.abs(e))}
                            disabled={disabled}
                            min={0}
                            style={{width: 100}}
                        />
                    </CompactFormItem>
                )}

                {!userIsCustomer && feeType === "KM" && (
                    <CompactFormItem>
                        <CompactLabel>Kurye Minimum Mesafe (km):</CompactLabel>
                        <InputNumber
                            className="payment-contract-form-input"
                            type="number"
                            size="small"
                            value={feeItem.courierMinimumDistance}
                            onChange={e => handleFieldChange("courierMinimumDistance", Math.abs(e))}
                            disabled={disabled}
                            min={0}
                            suffix="km"
                            style={{width: 70}}
                        />
                    </CompactFormItem>
                )}


                {feeType === "KM" && (
                    <CompactFormItem>
                        <CompactLabel>Müşteri Minimum Mesafe (km):</CompactLabel>
                        <InputNumber
                            className="payment-contract-form-input"
                            type="number"
                            size="small"
                            value={feeItem.clientMinimumDistance}
                            onChange={e => handleFieldChange("clientMinimumDistance", Math.abs(e))}
                            disabled={disabled}
                            min={0}
                            suffix="km"
                            style={{width: 70}}
                        />
                    </CompactFormItem>
                )}
                <CompactFormItem style={{maxWidth: "100%"}}>
                    <CompactLabel>Günler:</CompactLabel>
                    <Tooltip title={selectedDaysText}>
                        <Select
                            className="payment-contract-form-input"
                            mode="multiple"
                            size="small"
                            value={getSelectedDays()}
                            onChange={selectedDays => {
                                const newDays = {
                                    "0": false,
                                    "1": false,
                                    "2": false,
                                    "3": false,
                                    "4": false,
                                    "5": false,
                                    "6": false
                                };
                                selectedDays.forEach(dayName => {
                                    const day = daysList2.find(d => d.name === dayName);
                                    if (day) {
                                        newDays[day.value.toString()] = true;
                                    }
                                });
                                handleOptionsChange("days", newDays);
                            }}
                            disabled={disabled}
                            placeholder="Seç"
                            style={{minWidth: "70px", maxWidth: "100%"}}
                        >
                            {daysList2.map(day => (
                                <Select.Option key={day.value} value={day.name}>
                                    {day.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Tooltip>
                </CompactFormItem>
            </CustomTimeItemBody>

            <CustomTimeItemActions>
                {!disabled && (
                    <Tooltip title="Sil">
                        <RemoveButton onClick={() => onRemove(index)}>
                            <DeleteOutlined style={{fontSize: 12}} />
                        </RemoveButton>
                    </Tooltip>
                )}
            </CustomTimeItemActions>
        </CustomTimeItem>
    );
};
